import { render, staticRenderFns } from "./TraxTrainingCompetencyDomainsCrudForm.vue?vue&type=template&id=e6d768ee"
import script from "./TraxTrainingCompetencyDomainsCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyDomainsCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports